import React from 'react'
import { Trans } from 'react-i18next'
import classNames from 'classnames'
import type { CreditBalance } from '../../../shared/domain/credits/types.no-deps'
import { CreditBalanceText } from './CreditBalanceText'
import type { Nullable } from '../../../shared/lib/typeHelpers.no-deps'
import { isCreditBalanceVeryLow } from '../../../shared/domain/credits/helpers.no-deps'

type CreditBalanceBoxProps = {
    creditBalance: Nullable<CreditBalance>
    creditsCost?: number
    showCreditsCost?: boolean
}

export function CreditBalanceBox({ creditBalance, creditsCost, showCreditsCost = false }: CreditBalanceBoxProps) {
    return (
        <>
            <div
                className={classNames('AppCore__ui__CreditBalanceBox', {
                    'AppCore__ui__CreditBalanceBox--very-low': isCreditBalanceVeryLow(creditBalance, creditsCost),
                })}
            >
                <CreditBalanceText
                    creditBalance={creditBalance}
                    creditsCost={creditsCost}
                    i18nKey="appcore:CreditBalanceBox.creditsAvailable"
                />

                {creditsCost > 0 && showCreditsCost && (
                    <div className="AppCore__ui__CreditBalanceBox_cost">
                        <Trans i18nKey="appcore:CreditBalanceBox.generationCost">
                            <span className="AppCore__ui__CreditBalanceBox__creditsCount">{{ creditsCost }}</span>
                        </Trans>
                    </div>
                )}
            </div>

            {creditBalance && creditBalance.freeCreditsLimit > 0 && (
                <div className="AppCore__ui__CreditBalanceBox__freeCreditsInfo">
                    <span className="AppCore__ui__CreditBalanceBox__freeCreditsIcon">
                        <zaptic-icon icon-name="refresh"></zaptic-icon>
                    </span>
                    <Trans i18nKey="appcore:CreditBalanceBox.monthlyFreeCreditsInfo">
                        {creditBalance ? (
                            <span>{{ freeCreditsCount: creditBalance.freeCreditsLimit }}</span>
                        ) : (
                            <span className="AppCore__ui__CreditBalanceBox__freeCreditsCount--loading"></span>
                        )}
                    </Trans>
                </div>
            )}
        </>
    )
}
